import LoadStateMixin from '@/mixins/load-state-mixin';

export default {
    mixins: [LoadStateMixin],
    props: {
        id: String,
    },
    computed: {
        predicate() {
            return this.id !== undefined && this.id !== null;
        },
        isFormUpdating() {
            return !!this.predicate;
        },
        isDataRequired() {
            return this.isFormUpdating && !this.isDataReady;
        },
        newRecord() {
            return this.$route.query.newRecord;
        },
    },
    methods: {
        scrollTop() {
            window.scrollTo(0, 0);
        },
        beforeSaveDelegate() {
            return true;
        },
        async update() {
            throw Error('Update method must be implemented');
        },
        async create() {
            throw Error('Create method must be implemented');
        },
        async save(entity, validate = true) {
            if (this.$v) {
                // reset validation
                this.$v.$reset();
            }
            // reset server errors
            this.serverError = null;
            this.$v.$touch();
            if (!validate
                    || !this.$v
                    || !this.$v.$error
                    || !this.beforeSaveDelegate()) {
                try {
                    this.isLoading = true;
                    if (this.isFormUpdating) {
                        await this.update(entity);
                    } else {
                        await this.create(entity);
                    }
                } catch (error) {
                    this.serverError = error;
                } finally {
                    this.isLoading = false;
                }
            }
            this.scrollTop();
        },
    },
};
